import WNB_EXT_1 from "./WNB_EXT_1";
export default {
  WNB_EXT_1,
};
